import './Trading.scss';
import React, { useEffect } from 'react';
import {
  getPershingJWT,
  resetBrokerageMFE
} from 'services/Rest';
import { compose } from 'redux';
import { connect } from 'react-redux';
import {
  getBrokerageMFELogin,
  getBrokerageMFEState,
} from 'state/brokerage/BrokerageSelectors';
import Store from 'state/Store';
import {
  receivedBrokerageLogin,
  updateBrokerageMFEState
} from 'state/brokerage/BrokerageActions';
import { getLdapId } from 'state/customer/CustomerSelectors';
import PageLoadingSpinner from 'components/layouts/Navigation/PageLoadingSpinner';
import { MFE_STATE } from 'support/BrokerageMFEUtils';
import {
  AAMBeaconTab,
  AAMBeaconTabPanel,
  AAMBeaconTabs
} from 'components/shared/Beacon';
import ErrorPage from 'components/shared/ErrorPage/ErrorPage';

const BrokerageTradingMFE = ({ MFEState, mfeLoggedIn, ldapId }) => {
  useEffect(() => {
    return () => {
      resetBrokerageMFE();
    }
  }, []);

  const handleEvents = (event) => {
    if (event.msgid === 'PERMFE003') {
      // successful login
      Store.dispatch(receivedBrokerageLogin(true));
    }
    // Renew token event
    if (event.msgid === 'PERMFE007') {
      getPershingJWT(true, ldapId);
    }
    // Login Error
    if (event.msgid === 'PERMFE004') {
      Store.dispatch(updateBrokerageMFEState(MFE_STATE.ERROR));
    }
    //MFE Loading event
    if (event.msgid === 'PERMFE011') {
      if (event.text.includes('Loaded Module @pershing/nxi-ng-account')) {
        Store.dispatch(updateBrokerageMFEState(MFE_STATE.LOADED));
      }
    }
    //console.log('Pershing Event Log', event.msgid, event);
  }

  useEffect(() => {
    if (window && window.pershingMFEHelper && ldapId) {
      window.pershingMFEHelper.getPershingMFEEvents(handleEvents);
      if (mfeLoggedIn) {
        // Load the required MFE Modules form pershing
        window.pershingMFEHelper.loadModules([
          "nxi-ng-account",
          "trading-equity-app",
          "trading-order-status-app",
          "trading-mutualfund-app",
          "trading-options-app",
          "nxi-ng-pcf"]);
      } else {
        //Get the JWT token from the Pershing API
        getPershingJWT(false, ldapId);
      }
    }
  }, [mfeLoggedIn, ldapId]);

  const renderPage = () => {
    if (MFEState === MFE_STATE.LOADING) {
      return <PageLoadingSpinner name="Alerts & Notifications" />;
    }
    return (
      <div className="trading-mfe-wrapper blocked_data">
          <div className="blocked_data">
            <account-dropdown-app
              class="per-mfe-ns modern"
              ishouseholdpage="false"
              ismanagedaccountspage="false"
              showsingleaccounts={true}
              isTrading={true}
              pageid="NEWORDER"
            ></account-dropdown-app>
            <div>
              <AAMBeaconTabs
                scrollable={false}
                variant={'secondary'}
                tab-type={'standard'}
              >
                <AAMBeaconTab
                  role={'tab'}
                  slot={'tab-children'}
                  label={'Stocks & ETFs'}
                  value={'1'}
                />
                <AAMBeaconTab
                  role={'tab'}
                  slot={'tab-children'}
                  label={'Mutual Funds'}
                  value={'2'}
                />
                <AAMBeaconTab
                  role={'tab'}
                  slot={'tab-children'}
                  label={'Options'}
                  value={'3'}
                />
                <AAMBeaconTabPanel slot="tab-panel" value={'1'}>
                  <div className="b-grid">
                    <div className="b-grid-item--9-col">
                      <equity-order-entry-container-component class="per-mfe-ns modern" is-extended-hour={false} />
                      <equity-trading-disclaimers class="per-mfe-ns modern" data-testid='equity-trading-disclaimers' trade-type="EQUITY" />
                    </div>
                    <div className="b-grid-item--3-col">
                      <equity-trading-summary class="per-mfe-ns modern" />
                      <equity-trading-balances class="per-mfe-ns modern" />
                      <equity-trading-holding-container class="per-mfe-ns modern" />
                    </div>
                  </div>
                </AAMBeaconTabPanel>
                <AAMBeaconTabPanel slot="tab-panel" value={'2'}>
                  <div className="b-grid">
                    <div className="b-grid-item--9-col">
                      <mf-order-entry-container-component class="per-mfe-ns modern" isPlan529={false} is-plan529={false}/>
                      <mf-trading-disclaimers class="per-mfe-ns modern" trade-type="MUTUAL_FUND"/>
                    </div>
                    <div className="b-grid-item--3-col">
                      <mf-trading-summary class="per-mfe-ns modern" />
                      <mf-trading-balances class="per-mfe-ns modern" />
                      <mf-trading-holding-container class="per-mfe-ns modern" />
                    </div>
                  </div>
                </AAMBeaconTabPanel>
                <AAMBeaconTabPanel slot="tab-panel" value={'3'}>
                  <div className="b-grid">
                    <div className="b-grid-item--9-col">
                      <opt-order-entry-container-component class="per-mfe-ns modern"/>
                      <opt-trading-disclaimers trade-type="OPTION" class="per-mfe-ns modern"/>
                    </div>
                    <div className="b-grid-item--3-col">
                      <opt-trading-summary class="per-mfe-ns modern"/>
                      <opt-trading-balances class="per-mfe-ns modern"/>
                      <opt-trading-holding-container class="per-mfe-ns modern"/>
                    </div>
                  </div>
                </AAMBeaconTabPanel>
              </AAMBeaconTabs>
            </div>
        </div>
      </div>
    );
  };
  return MFEState === MFE_STATE.ERROR ? (
    <div>
      <ErrorPage />
    </div>
  ) : (
    renderPage()
  );
};

const mapStateToProps = (state) => ({
  MFEState: getBrokerageMFEState(state),
  mfeLoggedIn: getBrokerageMFELogin(state),
  ldapId: getLdapId(state)
});
export default compose(connect(mapStateToProps))(BrokerageTradingMFE);
